import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../../../services/tools/helpers.service';
import { ComercializacionService } from '../../../../../services/creditos/comercializacion.service';

@Component({
  selector: 'meses-subproducto',
  templateUrl: './meses-subproducto.component.html'
})
export class MesesSubproductoComponent implements OnInit {

    @Input() public idCreditos : number = null;
    @Input() public isCompleted : boolean = false;
    @Input() public idTipos_Creditos : number = null;
    @Input() public isEditable: boolean = false;
    @Output() public onDataUpdated : EventEmitter<string> = new EventEmitter;
    //Cliente form
    public credito : any = { subproducto: '' };
    public errors : any = {};
    private isInitialized : boolean = false;

    constructor(
      private helperService: HelpersService,
      private mesesService : ComercializacionService
    ){
    }

    ngOnInit() {
    }

    public loadComponent(){
      if(!this.isInitialized){
        this.getCredito(this.idCreditos);
        this.isInitialized = true;
      }
    }

    private getCredito(idCredito : number){
      
      //TODO: Manejar cuando el id no retorna un crédito valido
      this.mesesService.get(idCredito).subscribe(
        (response)=>
        {
          const result = response.json().content;
          this.credito = result.meses;
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    public save(){
      let creditoToSave = this.credito;

      //Si no fue ingresado la info del subproducto, poner estos campos como null para que se almacene correctamente la información
      if(!creditoToSave.subproducto){
        creditoToSave.subproducto = null;
      }

      this.errors = this.mesesService.validateSubproducto(creditoToSave);
      if (Object.entries(this.errors).length > 0) {
        return false;
      }

      this.mesesService.updateSubproducto(creditoToSave).subscribe(
        (response)=>
        {
          this.helperService.notification('Detalles del crédito actualizados', 'Se ha actualizado exitosamente la información del crédito ', 'success');
          this.onDataUpdated.emit();
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) { 
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
  }
}


// WEBPACK FOOTER //
// ./src/app/creditos/comercializacion/detalles/components/meses-subproducto/meses-subproducto.component.ts